import styled from 'styled-components'
import pxToRem from '../../utils/pxToRem'
import { Link } from 'gatsby'
import { deviceMax } from '../../theme/breakpoints'
import IconButton from '../IconButton/IconButton'

import ArrowDownIcon from '../../images/icons/arrow-down.svg'

export const StyledDropdownItem = styled.div`
  flex: 1;
  justify-content: space-between;
  align-items: center;
  display: flex;
  margin-bottom: ${pxToRem(20)};
  width: ${({ $hasSubItems }) => ($hasSubItems ? '100%' : 'auto')};
  text-align: start;

  -webkit-text-stroke-width: ${({ $isSelected }) =>
    $isSelected ? pxToRem(0.7) : 0};
  border-bottom: ${({ $isSelected, theme }) =>
    $isSelected
      ? `solid ${pxToRem(2)} ${theme.colors.primary.blue}`
      : `solid ${pxToRem(2)} ${theme.colors.unique.transparent}`};

  &:hover {
    border-bottom: ${({ theme }) =>
      `solid ${pxToRem(2)} ${theme.colors.primary.blue}`};
    /* add bold on text without change container size */
    -webkit-text-stroke-width: ${pxToRem(0.7)};
    -webkit-text-stroke-color: ${({ theme }) => theme.colors.primary.white};
  }
`

export const StyledLink = styled(Link)`
  font-size: ${({ theme }) => theme.fonts.sizes.titleH3};
  line-height: ${({ theme }) => theme.fonts.lineHeight.titleH3};

  @media ${deviceMax.laptop} {
    font-size: ${({ theme }) => theme.fonts.sizes.button};
    line-height: ${({ theme }) => theme.fonts.lineHeight.button};
  }
`

export const StyledIconButton = styled(IconButton)`
  margin-left: ${pxToRem(20)};
`

export const StyledArrowDownIcon = styled(ArrowDownIcon)`
  transition: all ease 0.3s;
  transform: ${({ $isSelected }) =>
    $isSelected ? `rotateZ(-90deg)` : 'initial'};
`
